import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import apiBusiness from "../../../../utils/apiBusiness";
import PlansX4 from "../../../golbal/sliders/plansX4";
import PopCatSlider from "../../../golbal/sliders/popCatSlider";
import BusCardSliderS1 from "../../../golbal/sliders/busCardSliderS1";
import api from "../../../../utils/api";
import HorizontalSlider from "../../../golbal/sliders/horizontalSlider";
import tools from "../../../../utils/tools";
import ColoredSpinner from "../../../alret/spiners/coloredSpiner/coloredSpinner";
// import renderData from "../../../../utils/renderData";
import MetaDecorator from "../../../../utils/metaDecorator";
import Tooltip1 from "../../../golbal/tooltip/tooltip";
// import { CircularProgress } from "@mui/material";
 
export default function BusinessHome() {
  const [pubData] = useOutletContext();
  const { lang, state:{state,stateShort}, country, countryShort } =
  tools.getItemFromLocalStorage("initSetup", {});
  
  
  const [busPopCat, setBusPopCat] = useState([]);
  const { translations, states } =
    JSON.parse(localStorage?.getItem("countryDetails")) ?? {};
  const navigate = useNavigate();
  const [cities, setCities] = useState([]);
  const [statesDetalis, setStatesDetalis] = useState([]);
  const [city, setCity] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const page = "busHome";
  const totalCount = statesDetalis?.reduce((a,c)=>a+c.count,0)
  const searchHandle = () => {
    window.scroll(0, 0);
    navigate(`filters?cities=${city}&searchKey=${searchKey}`);
    const storedFilters = JSON.parse(localStorage.getItem("storedFilters"));
    if (storedFilters?.business) {
      delete storedFilters.business;
      localStorage.setItem("storedFilters", JSON.stringify(storedFilters));
    }
  };
  function navigateHandle(url) {
    window.scroll(0, 0);
    setTimeout(() => navigate(url), 200);
  }

  useEffect(() => {
    tools.scrollToAnchor();
    fetchBusPopCat();
    getBusInStates()
  }, []);

  const [loading, setLoading] = useState(false);
  async function fetchCities() {
    if (cities.length > 0) return;
    setLoading(true);
    const response = await api.getCities(countryShort, stateShort);
    setLoading(false);
    if (response.error)
      return alert("مشکل در دریافت نام شهرها، کد خطا :" + response.error);
    setCities(response.data);
  }

  async function fetchBusPopCat() {
    const filters = {
      lang: window.lang,
      countryShort,
      stateShort,
      pageNumber: 1,
      itemsToShow: 12,
      sort: "dateB",
    };

    const response = await apiBusiness.getPopCat({ filters });
    if (response.error) return console.log(response.error);
    setBusPopCat(response.data);
  }
  async function getBusInStates() {
    const filters = {
      lang: window.lang,
      countryShort,
      stateShort,
      state,
      pageNumber: 1,
      itemsToShow: 12,
      sort: "dateB",
    };

    const response = await apiBusiness.getBusInStates({ filters });
    if (response.error) return console.log(response.error);
    setStatesDetalis(response.data);
  }
  // const title = `کسب و کارهای ایرانی ${translations?.[window.lang] + " - " +  window.capitalize(state)}  `;
  const title = `کسب و کارهای ایرانی کانادا و سراسر دنیا `;
  const description =' بانک کسب و کار و دایرکتوری بیزینس های ایرانی ';
  const structuredData = [
    // ...renderData.structuredData,
    {
      "@context": "http://schema.org",
      "@type": "WebPage",
      name: "متامارس ",
      url: window.location.href,
      breadcrumb: {
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            item: {
              "@id": "https://www.metamarce.com/",
              name: "شروع",
              description: "متامارس، پلی بین پارسی‌زبانان سراسر دنیا",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            item: {
              "@id": `https://www.metamarce.com/${window.lang}`,
              name: `خانه`,
              description:
                "پاسخی برای صاحبان و جستجوگران کسب و کارها، فرصت های شغلی، اینفلوئنسر ها، تولید کنندگان محتوا و... !",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            item: {
              "@id": `https://www.metamarce.com/${window.lang}/business`,
              name: ` کسب و کار | خانه`,
              description: `بیزینس های سراسر دنیا`,
            },
          },
        ],
      },
      // about: {
      //   "@type": "Place",
      //   name: state?.toUpperCase(),
      //   address: {
      //     "@type": "PostalAddress",
      //     // "addressLocality": "City",
      //     addressRegion: state?.toUpperCase(),
      //     // "postalCode": "Postal Code",
      //     addressCountry: country?.toUpperCase(),
      //   },
      //   // geo: {
      //   //   "@type": "GeoCoordinates",
      //   //   latitude: lat, // Replace with the actual latitude
      //   //   longitude: lng, // Replace with the actual longitude
      //   // },
      // },
    },
  ];

  const metaTagsData = {
    title,
    description,
    section: "business directory",
    url: `https://www.metamarce.com/${window.lang}/business`,   
    img: "https://www.metamarce.com/img/illustration/concept-of-remote-team.svg",
    type: "website",
  };
  return (
    <div>
      <MetaDecorator data={{ ...metaTagsData, structuredData }} />
      {loading && <ColoredSpinner />}
      <div className="my-header m-0">
        <div className="bg-image fixed-bg-listing "></div>
        {/* <div className="container px-4 px-lg-5 text-right header-listing-overlay align-center d-flex flex-column align-content-end "> */}
        <div className="row py-5">
          <div className="col-lg-6  ">
            <h1 className="mx-auto header-firstpage titr1 ">
              متامارس 
              {/* { translations?.['fa']} */}
            </h1>
            <h3 className="mx-auto header-firstpage titr3">
              راهنمای کسب و کارهای شهر شما
            </h3>
          </div>
          <div className="col-lg-6 text-center">
            {/* {/* <!-- <Link to={`/${window.lang}/`} className="   mx-auto  ">Metamarce</a> --> */}
            {/* <!-- <h1 className="titr2 mx-auto ">"Metamarce"</h1>  --> */}
            <p className="mx-auto mt-5 header-firstpage titr2 titr2plus">
              Metamarce
            </p>

            {/* <h3 className="titr4 mx-auto ">{window.capitalize(state)}</h3> */}
          </div>
        </div>
        <div className="search-sec align-items-end align-end ads-all my-md-0 my-5 mx-auto">
          <div>
            <div className="row ">
              <div className="col-lg-12">
                <div className="row  justify-content-center">
                  <div
                    className="col-lg-3 col-md-3 col-sm-12 p-0"
                    onClick={fetchCities}
                  >
                    <select
                      className="form-control search-slt search-slt2"
                      onChange={(e) => setCity(e.target.value.toLowerCase())}
                      name="citySel00"
                      title="شهر خود را انتخاب کنید "
                    >
                       {/* <CircularProgress color="inherit" size="20px" />  */}
                     
                       <option dir="rtl">شهر خود را انتخاب کنید 🜄 </option>
                      {cities?.map((city, i) => (
                        <option key={i}>{city.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12 p-0">
                    <input
                      type="text"
                      className="form-control search-slt search-slt1"
                      placeholder="دنبال چه چیزی می‌گردی؟ "
                      onChange={(e) => setSearchKey(e.target.value)}
                      name="seaechInputBusHome"
                    />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 p-0">
                    <button
                      type="button"
                      className="btn btn-danger wrn-btn"
                      onClick={searchHandle}
                    >
                      <i className="bi bi-search p-1"></i>
                      جستجوی سریع
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img
          src="/img/homePage/wave-haikei-3.svg"
          className=" p-0 py-0 w-100 overlay-b"
          alt="homePage"
        />
      </div>

      {/* {/* <!-- ******************************* --> */}
      <div className="mx-0 py-0">
        {/* <div className="row shift-down"></div> */}

        <div className=" pb-0">
          {/* {/* <!-- گروه‌های اصلی کسب و کار --> */}
          <div className="sections-gap special-carousel">
            <p className="divider2 mt-2">
               
              <svg
                className="text-dark-550 dark:text-white ml-2"
                width="50"
                height="50"
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="15" cy="27" r="11" fill="currentColor"></circle>
                <circle
                  cx="35"
                  cy="16"
                  r="8"
                  fill="currentColor"
                  fillOpacity="0.4"
                ></circle>
                <circle
                  cx="20"
                  cy="8"
                  r="5"
                  fill="currentColor"
                  fillOpacity="0.7"
                ></circle>
                {/* {/* <!-- <line x1="30" y1="20" x2="560" y2="20" stroke="currentColor" />  --> */}
              </svg>
              <span className="p-0 m-z ">گروه‌های اصلی کسب و کار</span>
            </p>

            <div className="row  row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-6 gx-4 gy-3 card-categories">
              {pubData.categories?.business?.map((cat, i) => (
                <div
                  key={i}
                  className="col 
                "
                >
                  <div className="card card4">
                    <div
                      className="cursor"
                      onClick={(e) =>
                        navigateHandle(
                          `filters?mainCat=${
                            cat.mainCat?.[window.lang]
                          }&mainCatId=${cat._id}&city=${city}`
                        )
                      }
                      title={cat.mainCat?.[window.lang]}
                      // aria-label={cat.mainCat?.[window.lang]}
                    >
                      {/* <div className="image-container m-3 image-container-bus">  */}
                      <img
                        src={cat.categoryPhoto}
                        className={`card-img-top card-img-categories p-3 card-background${i} `}
                        alt={"business main category" + i}
                      />
                      {/* </div> */}
                      <div className="card-body card-title-categories">
                        <h5 className="card-title card-title-categories text-center">
                          {cat.mainCat?.[window.lang]}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* <!-- گروه‌های اصلی کسب و کار end of --> */}

        

          {/* Why Metamarce for users */}
          <div className="px-md-5  mx-0 img-banner-text mt-5 ">
            <div className="row  banner-listing-2 w-100  max-w-1000 mx-auto">
              <div className="col-md-7  d-flex flex-column align-items-md-start align-items-center">
                <div style={{ position: "relative" }}>
                  <p className="titr1 mb-0 mt-3 ">چرا متامارس؟</p>
                  <div className="titr8">برای کاربران</div>{" "}
                </div>
                <ul className="my-3 px-1 flex-column text-start align-items-start">
                  {/* <li className="my-2" >
                <i className="bi bi-circle-fill fs-6 mx-2" style={{color:'var(--brown)'}}></i> 
                ثبت رایگان کسب و کار
                </li> */}
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    دسترسی مستقیم به کسب و کارها در سراسر دنیا
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    فیلترهای پیشرفته و جستجوی قدرتمند
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    امکان ثبت دیدگاه و امتیازدهی
                  </li>

                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    آشنایی با امکانات کسب‌ و‌ کارها
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    مسیریابی به کمک نقشه گوگل
                  </li>

                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    ذخیره و طبقه‌بندی کسب و کارها
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    استفاده آسان در تلفن همراه و کامپیوتر
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    حمایت از کسب و کارهای محلی
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    صرفه‌جویی در وقت و هزینه
                  </li>
                </ul>
              </div>
              <div className="col-md-5 d-flex align-items-center justify-content-center img-banner-2 display-none-md">
                <img
                  className="w-100 px-md-5"
                  src="/img/illustration/concept-of-remote-team.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="divider2 ">
             
            <svg
              className="text-dark-550 dark:text-white ml-2"
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="15" cy="27" r="11" fill="currentColor"></circle>
              <circle
                cx="35"
                cy="16"
                r="8"
                fill="currentColor"
                fillOpacity="0.4"
              ></circle>
              <circle
                cx="20"
                cy="8"
                r="5"
                fill="currentColor"
                fillOpacity="0.7"
              ></circle>
            </svg>
            <span className="p-0 mb-0 ">معرفی ویژه</span>
          </div>
          <PlansX4 plansX4={pubData?.ads?.plansX4} page={page} />
          {/* Why Metamarce for businesses */}
          <div
            className="px-md-5 img-banner-text-2 mx-0 my-5 "
            id="MetamarceBus"
          >
            <div className="row  banner-listing-2 w-100  ads-all mx-auto">
              <div className="col-md-5 d-flex align-items-center justify-content-center p-lg-5 img-banner-2 display-none-md">
                <img
                  className="w-100 px-md-5"
                  src="/img/illustration/buy-photography-gear-online.svg"
                  alt=""
                />
              </div>
              <div className="col-md-7  d-flex flex-column align-items-md-start align-items-center">
                <div style={{ position: "relative" }}>
                  <p className="titr1 mb-0 mt-3 ">چرا متامارس؟</p>
                  <div className="titr8 titr8-5">برای کسب‌و‌کار</div>{" "}
                </div>
                <ul className="my-3 px-1 flex-column text-start align-items-start">
                  {/* <li className="my-2" >
                <i className="bi bi-circle-fill fs-6 mx-2" style={{color:'var(--brown)'}}></i> 
                ثبت رایگان کسب و کار
                </li> */}
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    ثبت نام آسان، سریع و رایگان
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    داشتن صفحه اختصاصی کسب و کار
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    سیستم رایگان رزرو قرار ملاقات{" "}
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    دریافت دیدگاه‌های کاربران و سیستم امتیازدهی
                  </li>

                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    مدیریت و به روزرسانی اطلاعات و تصاویر
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    مسیریابی به کمک نقشه گوگل
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    فرصت‌ شبکه‌سازی
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    دسترسی به آمار صفحه
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    مخاطبین هدفمند بر اساس استان و کشور
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    بهینه‌سازی موتور جستجو
                  </li>
                </ul>
                <div
                  className="btn primary-btn view-cart cart-footer w-75 mx-md-5 mx-0 mb-5"
                  onClick={(e) => {
                    if (!window.logined(9999,"business")) {
                      return window.navigateHandle(
                         `/${window.lang}/business/register`
                       );
                     };
                    navigateHandle(
                      `/${window.lang}/dashboard/user/business/register`
                    );
                  }}
                >
                  <i className="bi bi-pencil-square p-1"></i>
                  افزودن کسب و کار
                </div>
                {/* <!-- </button> --> */}
              </div>
            </div>
          </div>
          <div className="text-center max-w-1000 mx-auto my-5">
            <div className="titr1  mb-4 font-40">
              صفحه اختصاصی کسب و کارت رو بساز و قرار ملاقات‌هات رو تنظیم کن!{" "}
            </div>

            <div className="row px-3 py-md-5 g-3 ">
              {/* <div className="col-md-3">
            <div className="card w-100">
              <img
              
              
                src="/img/Metademy/teacher.png"
                className="card-img-top w-25 mx-auto"
                alt="متادمی چطور کار می‌کنه"
              />
              <div className="card-body">
                <h5 className="card-title titr5">۱- ساخت حساب کاربری</h5>
                <p className="card-text">در اولین گام باید یک حساب کاربری در متامارس بسازید. به تنها چیزی که نیاز دارید یک ایمیل یا شماره تلفنه! 
                </p>
              </div>
            </div>
          </div> */}
              <div className="col-md-3 ">
                <div className="card w-100">
                  <img
                    src="/img/icons/favorites.png"
                    className="card-img-top w-25 mx-auto"
                    alt="ثبت کسب و کار"
                  />
                  <div className="card-body">
                    <h5 className="card-title titr5"> ۱- ثبت کسب و کار</h5>
                    <p className="card-text">
                      صفحه کسب و کارتون در متامارس رو می‌سازید و اطلاعات و
                      عکس‌های معرفی اون رو هم اضافه می‌کنید.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card w-100">
                  <img
                    src="/img/icons/time.png"
                    className="card-img-top w-25 mx-auto"
                    alt="تنظیم جدول کاری کارمندان" 
                  />
                  <div className="card-body">
                    <h5 className="card-title titr5">
                      {" "}
                      ۲- تنظیم جدول کاری کارمندان
                    </h5>
                    <p className="card-text">
                      ساعت‌‌های قرار ملاقات خودتون و کارمندانتون را وارد جدول
                      قرار ملاقات‌های کسب و کار می‌کنید.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card w-100">
                  <img
                    src="/img/icons/calendar-2.png"
                    className="card-img-top w-25 mx-auto"
                    alt=" شرکت در کلاس"
                  />
                  <div className="card-body">
                    <h5 className="card-title titr5">
                      {" "}
                      ۳- رزور قرار ملاقات توسط مشتریان{" "}
                    </h5>
                    <p className="card-text">
                      مشتریان شما روز و ساعت مورد نظرشون رو به صورت مستقیم از
                      صفحه کسب و کار رزرو می‌کنند.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card w-100">
                  <img
                    src="/img/icons/interview.png"
                    className="card-img-top w-25 mx-auto"
                    alt=" شرکت در کلاس"
                  />
                  <div className="card-body">
                    <h5 className="card-title titr5">
                      ۴- ملاقات مشتری در زمان رزرو شده
                    </h5>
                    <p className="card-text">
                      پس از تایید شما، در روز و ساعت رزرو شده، مشتری به شما
                      مراجعه می‌کند.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="btn primary-btn tutor-btn  shadow-none mt-4"
              onClick={(e) => {
                if (!window.logined(9999,"business")) {
                  return window.navigateHandle(
                     `/${window.lang}/business/register`
                   );
                 };
                navigateHandle(
                  `/${window.lang}/dashboard/user/business/register`
                );
              }}
            >
              <i className="bi bi-pencil-square p-1"></i>
              افزودن کسب و کار
            </div>
          </div>
          <div className="similar-blog mx-auto py-3 ">
            <div className="divider2 mb-3  mt-0 ">
               
              <svg
                className="text-dark-550 dark:text-white ml-2"
                width="50"
                height="50"
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="15" cy="27" r="11" fill="currentColor"></circle>
                <circle
                  cx="35"
                  cy="16"
                  r="8"
                  fill="currentColor"
                  fillOpacity="0.4"
                ></circle>
                <circle
                  cx="20"
                  cy="8"
                  r="5"
                  fill="currentColor"
                  fillOpacity="0.7"
                ></circle>
                {/* <!-- <line x1="30" y1="20" x2="560" y2="20" stroke="currentColor" />  --> */}
              </svg>
              <span className="p-0 mb-0 ">برگزیدگان</span>
            </div>

            <BusCardSliderS1 plansS1={pubData.ads?.plansS1} page={page} />
          </div>
          {/* <!-- معرفی ویژه end of --> */}

          {/* <!-- banner 1 you want to be in this list--> */}
          <div className="px-md-5 img-banner-text-2 mx-0 my-5 ">
            <div className="row  banner-listing-2 w-100  ads-all mx-auto">
              <div className="col-md-7  d-flex flex-column align-items-center  justify-content-center ">
                <p className="h5 text-center p-5 titr5 cursor-pointer">
                  شما هم دلتون می‌خواد کسب و کارتون رو معرفی کنید و از همه این
                  امکانات به صورت
                  <strong> رایگان </strong>
                  بهره‌مند بشید؟
                </p>

                <p className="h5 text-center titr7">
                  همین حالا ثبت نام کنید!
                  <span className="ms-auto ">
                    <svg
                      className="arrow-position2"
                      viewBox="0 0 98 129"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M47.029 72.7354C50.0557 71.6329 52.8873 70.0549 55.4172 68.061C57.918 66.0579 60.1214 63.7096 61.9613 61.0864C63.8091 58.5597 65.3461 55.8197 66.5391 52.9257C67.7364 50.0386 68.4208 46.9647 68.5614 43.8423C68.6206 42.2624 68.4539 40.6823 68.0664 39.1495C67.6842 37.5558 66.9595 36.0643 65.9428 34.7789C64.7806 33.3631 63.1784 32.3767 61.3909 31.9766C59.5532 31.6118 57.6498 31.7712 55.8983 32.4365C55.0759 32.7319 54.2792 33.094 53.5159 33.5193C52.8228 33.9419 52.1521 34.4002 51.5067 34.8924C50.8464 35.3833 50.2154 35.9122 49.6168 36.4767L48.7047 37.3268L47.9174 38.176C45.9117 40.3826 44.1355 42.7873 42.6161 45.3531C41.0832 47.8361 39.9117 50.5248 39.1369 53.3382C38.4021 56.0043 38.062 58.7636 38.1276 61.5283L38.1352 62.5269L38.2181 63.5108C38.2949 64.1638 38.3506 64.8288 38.426 65.4547C38.6641 66.713 38.8388 68.0071 39.1613 69.2176C39.3611 69.9404 39.5715 70.6571 39.797 71.3514C39.1183 71.4567 38.4336 71.5514 37.7521 71.6025C35.0578 71.8377 32.3439 71.7042 29.6857 71.2059C27.1472 70.7067 24.7021 69.8151 22.4382 68.5631C18.1815 66.0403 14.5592 62.5759 11.8492 58.4358C9.29381 54.5665 7.28986 50.3601 5.89515 45.9379C4.59231 41.9013 3.61834 37.7659 2.98278 33.5722C2.37826 29.925 2.02126 26.2411 1.91425 22.5457C1.70973 17.104 2.3983 11.6657 3.9526 6.44679C5.16315 2.72557 6.29982 0.745502 6.07447 0.691869C5.84913 0.638235 5.6891 1.11877 5.13313 2.03216C4.35997 3.37851 3.68579 4.77932 3.11593 6.22352C1.15449 11.494 0.148942 17.0721 0.146538 22.6957C0.0827322 30.8741 1.20309 39.0187 3.47277 46.8761C4.84019 51.5314 6.86593 55.9674 9.48854 60.0495C12.359 64.5675 16.2315 68.3638 20.8056 71.144C23.3087 72.5646 26.0167 73.5892 28.8333 74.1813C31.7991 74.7897 34.8346 74.9853 37.8539 74.7626C38.8963 74.7008 39.9342 74.5788 40.9626 74.3974C42.0487 77.0395 43.365 79.5811 44.8961 81.9928C49.0382 88.373 54.1048 94.1027 59.9301 98.9944C64.1151 102.568 68.5796 105.8 73.2808 108.66C78.4719 111.87 83.9951 114.51 89.7538 116.532C90.4657 116.756 91.0559 116.938 91.5846 117.085L89.8096 117.517C87.9185 118.016 86.1129 118.591 84.4109 119.178C81.4044 120.241 78.4811 121.526 75.6654 123.024C70.8732 125.609 68.3039 127.814 68.5339 128.171C68.7639 128.529 71.7657 127.137 76.6077 125.207C79.0452 124.246 81.9645 123.152 85.2533 122.17C86.8948 121.673 88.6234 121.183 90.4314 120.76C91.3377 120.539 92.2605 120.324 93.2012 120.14C93.6785 120.024 94.0938 119.97 94.7849 119.788C95.6863 119.554 96.4869 119.033 97.0653 118.303C97.3671 117.906 97.5841 117.452 97.7028 116.967C97.7854 116.588 97.8184 116.199 97.8012 115.811C97.7666 115.238 97.6738 114.67 97.5245 114.115C97.2833 113.221 97.0481 112.337 96.8248 111.474C96.3407 109.756 95.8652 108.103 95.4151 106.519C94.4514 103.387 93.4861 100.645 92.63 98.3437C90.8863 93.7582 89.4203 90.9936 88.9623 91.169C88.5044 91.3445 89.0609 94.3727 90.2022 99.1736C90.8155 101.613 91.4858 104.423 92.2553 107.582L93.4801 112.53C93.6928 113.399 93.9055 114.268 94.1136 115.153L94.1554 115.227C93.4908 114.864 92.5499 114.408 91.1826 113.788C85.8335 111.319 80.6587 108.489 75.6942 105.317C71.2264 102.459 66.9737 99.2775 62.9701 95.7986C57.4752 91.1225 52.6808 85.6811 48.7339 79.6412C47.4482 77.6274 46.327 75.5132 45.3812 73.3191C45.9369 73.1441 46.4926 72.9692 47.0409 72.7565L47.029 72.7354ZM43.4862 67.8998C43.1601 66.8307 43.0267 65.7082 42.7956 64.5853C42.7124 64.0195 42.6833 63.4509 42.6107 62.8791L42.5228 62.0095L42.5221 61.1462C42.4528 58.7661 42.7319 56.3886 43.3504 54.0892C44.0065 51.6603 45.0047 49.337 46.315 47.1891C47.665 44.8794 49.2338 42.7048 50.9997 40.6951L51.6783 39.9492L52.3986 39.2772C52.8665 38.8172 53.3632 38.3874 53.8856 37.9904C54.3858 37.6017 54.9076 37.2415 55.4484 36.9115C55.9708 36.6141 56.5172 36.361 57.0819 36.1548C58.0155 35.7022 59.0732 35.5735 60.0881 35.7891C61.1029 36.0046 62.017 36.5521 62.6861 37.3451C64.0769 39.295 64.7488 41.6667 64.5873 44.0563C64.4873 46.7312 63.924 49.3685 62.9226 51.8509C61.88 54.4673 60.5227 56.9469 58.8806 59.2351C57.2951 61.5697 55.386 63.6671 53.2105 65.4645C51.0022 67.2219 48.5304 68.6198 45.8864 69.6068C45.3169 69.8314 44.7296 70.0243 44.1633 70.2053C43.902 69.4477 43.6558 68.6676 43.4234 67.8379"
                        fill="#CACFD8"
                      ></path>
                    </svg>
                  </span>
                </p>
                {/* <!-- <button type="button" className="btn btn-danger wrn-btn wrn-btn-rounded w-50 "> --> */}
                <div
                  className="btn primary-btn view-cart cart-footer w-75 mx-md-5 mx-0 mb-5"
                  onClick={(e) => {
                    if (!window.logined(9999,"business")) {
                      return window.navigateHandle(
                         `/${window.lang}/business/register`
                       );
                     };
                    navigateHandle(
                      `/${window.lang}/dashboard/user/business/register`
                    );
                  }}
                >
                  <i className="bi bi-pencil-square p-1"></i>
                  افزودن کسب و کار
                </div>
                {/* <!-- </button> --> */}
              </div>
              <div className="col-md-5 d-flex align-items-center justify-content-center p-5 img-banner-2 display-none-md">
                <img
                  className="w-100 px-md-5"
                  src="/img/illustration/content-creator.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>

        <div>
          {/* <div className=" mt-0 py-5 banner-listing-2 img-banner-text-3 "> */}
          <div className="divider2 mb-3  mt-0 ">
             
            <svg
              className="text-dark-550 dark:text-white ml-2"
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="15" cy="27" r="11" fill="currentColor"></circle>
              <circle
                cx="35"
                cy="16"
                r="8"
                fill="currentColor"
                fillOpacity="0.4"
              ></circle>
              <circle
                cx="20"
                cy="8"
                r="5"
                fill="currentColor"
                fillOpacity="0.7"
              ></circle>
              {/* <!-- <line x1="30" y1="20" x2="560" y2="20" stroke="currentColor" />  --> */}
            </svg>
            <span className="p-0 mb-0 ">کسب‌و‌کارهای طبقه‌بندی شده</span>
          </div>
          {busPopCat?.length > 0 && (
            <PopCatSlider data={busPopCat} section="business" />
          )}
        </div>
      </div>
      <div className=" pb-0">
          {/* {/* <!-- گروه‌های اصلی کسب و کار --> */}
          <div className="sections-gap special-carousel">
            <p className="divider2 mt-2">
               
              <svg
                className="text-dark-550 dark:text-white ml-2"
                width="50"
                height="50"
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="15" cy="27" r="11" fill="currentColor"></circle>
                <circle
                  cx="35"
                  cy="16"
                  r="8"
                  fill="currentColor"
                  fillOpacity="0.4"
                ></circle>
                <circle
                  cx="20"
                  cy="8"
                  r="5"
                  fill="currentColor"
                  fillOpacity="0.7"
                ></circle>
                {/* {/* <!-- <line x1="30" y1="20" x2="560" y2="20" stroke="currentColor" />  --> */}
              </svg>
              <span className="p-0 m-z ">گروه‌های اصلی کسب و کار</span>
            </p>

            <div className="row  row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-6 gx-4 gy-3 card-categories">
              {pubData.categories?.business?.map((cat, i) => (
                <div
                  key={i}
                  className="col 
                "
                >
                  <div className="card card4">
                    <div
                      className="cursor"
                      onClick={(e) =>
                        navigateHandle(
                          `filters?mainCat=${
                            cat.mainCat?.[window.lang]
                          }&mainCatId=${cat._id}&city=${city}`
                        )
                      }
                      title={cat.mainCat?.[window.lang]}
                      // aria-label={cat.mainCat?.[window.lang]}
                    >
                      {/* <div className="image-container m-3 image-container-bus">  */}
                      <img
                        src={cat.categoryPhoto}
                        className={`card-img-top card-img-categories p-3 card-background${i} `}
                        alt={"business main category" + i}
                      />
                      {/* </div> */}
                      <div className="card-body card-title-categories">
                        <h5 className="card-title card-title-categories text-center">
                          {cat.mainCat?.[window.lang]}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* <!-- گروه‌های اصلی کسب و کار end of --> */}

        

          {/* Why Metamarce for users */}
          <div className="px-md-5  mx-0 img-banner-text mt-5 ">
            <div className="row  banner-listing-2 w-100  max-w-1000 mx-auto">
              <div className="col-md-7  d-flex flex-column align-items-md-start align-items-center">
                <div style={{ position: "relative" }}>
                  <p className="titr1 mb-0 mt-3 ">چرا متامارس؟</p>
                  <div className="titr8">برای کاربران</div>{" "}
                </div>
                <ul className="my-3 px-1 flex-column text-start align-items-start">
                  {/* <li className="my-2" >
                <i className="bi bi-circle-fill fs-6 mx-2" style={{color:'var(--brown)'}}></i> 
                ثبت رایگان کسب و کار
                </li> */}
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    دسترسی مستقیم به کسب و کارها در سراسر دنیا
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    فیلترهای پیشرفته و جستجوی قدرتمند
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    امکان ثبت دیدگاه و امتیازدهی
                  </li>

                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    آشنایی با امکانات کسب‌ و‌ کارها
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    مسیریابی به کمک نقشه گوگل
                  </li>

                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    ذخیره و طبقه‌بندی کسب و کارها
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    استفاده آسان در تلفن همراه و کامپیوتر
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    حمایت از کسب و کارهای محلی
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    صرفه‌جویی در وقت و هزینه
                  </li>
                </ul>
              </div>
              <div className="col-md-5 d-flex align-items-center justify-content-center img-banner-2 display-none-md">
                <img
                  className="w-100 px-md-5"
                  src="/img/illustration/concept-of-remote-team.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="divider2 ">
             
            <svg
              className="text-dark-550 dark:text-white ml-2"
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="15" cy="27" r="11" fill="currentColor"></circle>
              <circle
                cx="35"
                cy="16"
                r="8"
                fill="currentColor"
                fillOpacity="0.4"
              ></circle>
              <circle
                cx="20"
                cy="8"
                r="5"
                fill="currentColor"
                fillOpacity="0.7"
              ></circle>
            </svg>
            <span className="p-0 mb-0 ">معرفی ویژه</span>
          </div>
          <PlansX4 plansX4={pubData?.ads?.plansX4} page={page} />
          {/* Why Metamarce for businesses */}
          <div
            className="px-md-5 img-banner-text-2 mx-0 my-5 "
            id="MetamarceBus"
          >
            <div className="row  banner-listing-2 w-100  ads-all mx-auto">
              <div className="col-md-5 d-flex align-items-center justify-content-center p-lg-5 img-banner-2 display-none-md">
                <img
                  className="w-100 px-md-5"
                  src="/img/illustration/buy-photography-gear-online.svg"
                  alt=""
                />
              </div>
              <div className="col-md-7  d-flex flex-column align-items-md-start align-items-center">
                <div style={{ position: "relative" }}>
                  <p className="titr1 mb-0 mt-3 ">چرا متامارس؟</p>
                  <div className="titr8 titr8-5">برای کسب‌و‌کار</div>{" "}
                </div>
                <ul className="my-3 px-1 flex-column text-start align-items-start">
                  {/* <li className="my-2" >
                <i className="bi bi-circle-fill fs-6 mx-2" style={{color:'var(--brown)'}}></i> 
                ثبت رایگان کسب و کار
                </li> */}
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    ثبت نام آسان، سریع و رایگان
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    داشتن صفحه اختصاصی کسب و کار
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    سیستم رایگان رزرو قرار ملاقات{" "}
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    دریافت دیدگاه‌های کاربران و سیستم امتیازدهی
                  </li>

                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    مدیریت و به روزرسانی اطلاعات و تصاویر
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    مسیریابی به کمک نقشه گوگل
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    فرصت‌ شبکه‌سازی
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    دسترسی به آمار صفحه
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    مخاطبین هدفمند بر اساس استان و کشور
                  </li>
                  <li className="my-2">
                    <i
                      className="bi bi-circle-fill fs-6 mx-2"
                      style={{ color: "var(--brown)" }}
                    ></i>
                    بهینه‌سازی موتور جستجو
                  </li>
                </ul>
                <div
                  className="btn primary-btn view-cart cart-footer w-75 mx-md-5 mx-0 mb-5"
                  onClick={(e) => {
                    if (!window.logined(9999,"business")) {
                      return window.navigateHandle(
                         `/${window.lang}/business/register`
                       );
                     };
                    navigateHandle(
                      `/${window.lang}/dashboard/user/business/register`
                    );
                  }}
                >
                  <i className="bi bi-pencil-square p-1"></i>
                  افزودن کسب و کار
                </div>
                {/* <!-- </button> --> */}
              </div>
            </div>
          </div>
          <div className="text-center max-w-1000 mx-auto my-5">
            <div className="titr1  mb-4 font-40">
              صفحه اختصاصی کسب و کارت رو بساز و قرار ملاقات‌هات رو تنظیم کن!{" "}
            </div>

            <div className="row px-3 py-md-5 g-3 ">
              {/* <div className="col-md-3">
            <div className="card w-100">
              <img
              
              
                src="/img/Metademy/teacher.png"
                className="card-img-top w-25 mx-auto"
                alt="متادمی چطور کار می‌کنه"
              />
              <div className="card-body">
                <h5 className="card-title titr5">۱- ساخت حساب کاربری</h5>
                <p className="card-text">در اولین گام باید یک حساب کاربری در متامارس بسازید. به تنها چیزی که نیاز دارید یک ایمیل یا شماره تلفنه! 
                </p>
              </div>
            </div>
          </div> */}
              <div className="col-md-3 ">
                <div className="card w-100">
                  <img
                    src="/img/icons/favorites.png"
                    className="card-img-top w-25 mx-auto"
                    alt="ثبت کسب و کار"
                  />
                  <div className="card-body">
                    <h5 className="card-title titr5"> ۱- ثبت کسب و کار</h5>
                    <p className="card-text">
                      صفحه کسب و کارتون در متامارس رو می‌سازید و اطلاعات و
                      عکس‌های معرفی اون رو هم اضافه می‌کنید.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card w-100">
                  <img
                    src="/img/icons/time.png"
                    className="card-img-top w-25 mx-auto"
                    alt="تنظیم جدول کاری کارمندان" 
                  />
                  <div className="card-body">
                    <h5 className="card-title titr5">
                      {" "}
                      ۲- تنظیم جدول کاری کارمندان
                    </h5>
                    <p className="card-text">
                      ساعت‌‌های قرار ملاقات خودتون و کارمندانتون را وارد جدول
                      قرار ملاقات‌های کسب و کار می‌کنید.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card w-100">
                  <img
                    src="/img/icons/calendar-2.png"
                    className="card-img-top w-25 mx-auto"
                    alt=" شرکت در کلاس"
                  />
                  <div className="card-body">
                    <h5 className="card-title titr5">
                      {" "}
                      ۳- رزور قرار ملاقات توسط مشتریان{" "}
                    </h5>
                    <p className="card-text">
                      مشتریان شما روز و ساعت مورد نظرشون رو به صورت مستقیم از
                      صفحه کسب و کار رزرو می‌کنند.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card w-100">
                  <img
                    src="/img/icons/interview.png"
                    className="card-img-top w-25 mx-auto"
                    alt=" شرکت در کلاس"
                  />
                  <div className="card-body">
                    <h5 className="card-title titr5">
                      ۴- ملاقات مشتری در زمان رزرو شده
                    </h5>
                    <p className="card-text">
                      پس از تایید شما، در روز و ساعت رزرو شده، مشتری به شما
                      مراجعه می‌کند.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="btn primary-btn tutor-btn  shadow-none mt-4"
              onClick={(e) => {
                if (!window.logined(9999,"business")) {
                  return window.navigateHandle(
                     `/${window.lang}/business/register`
                   );
                 };
                navigateHandle(
                  `/${window.lang}/dashboard/user/business/register`
                );
              }}
            >
              <i className="bi bi-pencil-square p-1"></i>
              افزودن کسب و کار
            </div>
          </div>
         
          {/* <!-- معرفی ویژه end of --> */}
        </div>
 {/* گستردگی متامارس */}
 <div className="similar-blog mx-auto py-3 ">
            <div className="divider2 mb-3  mt-0 ">
               
              <svg
                className="text-dark-550 dark:text-white ml-2"
                width="50"
                height="50"
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="15" cy="27" r="11" fill="currentColor"></circle>
                <circle
                  cx="35"
                  cy="16"
                  r="8"
                  fill="currentColor"
                  fillOpacity="0.4"
                ></circle>
                <circle
                  cx="20"
                  cy="8"
                  r="5"
                  fill="currentColor"
                  fillOpacity="0.7"
                ></circle>
                {/* <!-- <line x1="30" y1="20" x2="560" y2="20" stroke="currentColor" />  --> */}
              </svg>
              <span className="p-0 mb-0 ">  کسب و کارهای {translations?.[window.lang]} <span className="font-18">({tools.dynamicNumber({number:totalCount, lang:window.lang})})</span></span>
            </div>
            <div>
             
              <ul className="d-flex flex-row flex-wrap">
                {statesDetalis.slice(0,3)?.map((da,i)=>{
                  const state = window.capitalize(
                    da._id.state
                  )
                  return <li key={i} className={`p-2 rounded ${stateShort ===da._id.stateShort ?'bg-beigeDark':""}`}>
                  
                  <div 
                   data-bs-toggle="offcanvas"
                   data-bs-target="#offcanvasScrolling2"
                   aria-controls="offcanvasScrolling2"
                  >
                    <div >
                      {state}
                    </div>
                  {/* <Tooltip1
                      key={da?._id.state}
                      message={state}
                      icon={
                  <img
                          // width="25px"
                          style={{ width: "35px" }}
                          className="flag"
                          src={`/img/flags/${da._id.countryShort}.svg`}
                          alt={state}
                          title={state}
                        />}
                        /> */}
                        <div className="text-center fw-bold" >{tools.dynamicNumber({number:da.count, lang:window.lang})}</div>
                  </div>
                     
                </li>})}
              </ul>

          </div>

          </div>
     

      {/* <!-- banner 2 you want to shine in this list--> */}
      <div className="px-md-5 img-banner-text-8 mx-0">
        <div className="row  banner-listing-2 w-100   ">
          <div className="col-md-7  d-flex flex-column align-items-center justify-content-center">
            {/* <p className=" text-center p-md-2 titr5">
                اگه دوست دارید بین کسب و کارهای دیگه بدرخشید،
              </p> */}
            <p className="text-center titr7 mt-3">
              چگونه بین کسب و کارهای دیگه بدرخشید؟
              {/* <span className="ms-auto ">
                  <svg
                    className="arrow-position2"
                  
                    viewBox="0 0 98 129"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M47.029 72.7354C50.0557 71.6329 52.8873 70.0549 55.4172 68.061C57.918 66.0579 60.1214 63.7096 61.9613 61.0864C63.8091 58.5597 65.3461 55.8197 66.5391 52.9257C67.7364 50.0386 68.4208 46.9647 68.5614 43.8423C68.6206 42.2624 68.4539 40.6823 68.0664 39.1495C67.6842 37.5558 66.9595 36.0643 65.9428 34.7789C64.7806 33.3631 63.1784 32.3767 61.3909 31.9766C59.5532 31.6118 57.6498 31.7712 55.8983 32.4365C55.0759 32.7319 54.2792 33.094 53.5159 33.5193C52.8228 33.9419 52.1521 34.4002 51.5067 34.8924C50.8464 35.3833 50.2154 35.9122 49.6168 36.4767L48.7047 37.3268L47.9174 38.176C45.9117 40.3826 44.1355 42.7873 42.6161 45.3531C41.0832 47.8361 39.9117 50.5248 39.1369 53.3382C38.4021 56.0043 38.062 58.7636 38.1276 61.5283L38.1352 62.5269L38.2181 63.5108C38.2949 64.1638 38.3506 64.8288 38.426 65.4547C38.6641 66.713 38.8388 68.0071 39.1613 69.2176C39.3611 69.9404 39.5715 70.6571 39.797 71.3514C39.1183 71.4567 38.4336 71.5514 37.7521 71.6025C35.0578 71.8377 32.3439 71.7042 29.6857 71.2059C27.1472 70.7067 24.7021 69.8151 22.4382 68.5631C18.1815 66.0403 14.5592 62.5759 11.8492 58.4358C9.29381 54.5665 7.28986 50.3601 5.89515 45.9379C4.59231 41.9013 3.61834 37.7659 2.98278 33.5722C2.37826 29.925 2.02126 26.2411 1.91425 22.5457C1.70973 17.104 2.3983 11.6657 3.9526 6.44679C5.16315 2.72557 6.29982 0.745502 6.07447 0.691869C5.84913 0.638235 5.6891 1.11877 5.13313 2.03216C4.35997 3.37851 3.68579 4.77932 3.11593 6.22352C1.15449 11.494 0.148942 17.0721 0.146538 22.6957C0.0827322 30.8741 1.20309 39.0187 3.47277 46.8761C4.84019 51.5314 6.86593 55.9674 9.48854 60.0495C12.359 64.5675 16.2315 68.3638 20.8056 71.144C23.3087 72.5646 26.0167 73.5892 28.8333 74.1813C31.7991 74.7897 34.8346 74.9853 37.8539 74.7626C38.8963 74.7008 39.9342 74.5788 40.9626 74.3974C42.0487 77.0395 43.365 79.5811 44.8961 81.9928C49.0382 88.373 54.1048 94.1027 59.9301 98.9944C64.1151 102.568 68.5796 105.8 73.2808 108.66C78.4719 111.87 83.9951 114.51 89.7538 116.532C90.4657 116.756 91.0559 116.938 91.5846 117.085L89.8096 117.517C87.9185 118.016 86.1129 118.591 84.4109 119.178C81.4044 120.241 78.4811 121.526 75.6654 123.024C70.8732 125.609 68.3039 127.814 68.5339 128.171C68.7639 128.529 71.7657 127.137 76.6077 125.207C79.0452 124.246 81.9645 123.152 85.2533 122.17C86.8948 121.673 88.6234 121.183 90.4314 120.76C91.3377 120.539 92.2605 120.324 93.2012 120.14C93.6785 120.024 94.0938 119.97 94.7849 119.788C95.6863 119.554 96.4869 119.033 97.0653 118.303C97.3671 117.906 97.5841 117.452 97.7028 116.967C97.7854 116.588 97.8184 116.199 97.8012 115.811C97.7666 115.238 97.6738 114.67 97.5245 114.115C97.2833 113.221 97.0481 112.337 96.8248 111.474C96.3407 109.756 95.8652 108.103 95.4151 106.519C94.4514 103.387 93.4861 100.645 92.63 98.3437C90.8863 93.7582 89.4203 90.9936 88.9623 91.169C88.5044 91.3445 89.0609 94.3727 90.2022 99.1736C90.8155 101.613 91.4858 104.423 92.2553 107.582L93.4801 112.53C93.6928 113.399 93.9055 114.268 94.1136 115.153L94.1554 115.227C93.4908 114.864 92.5499 114.408 91.1826 113.788C85.8335 111.319 80.6587 108.489 75.6942 105.317C71.2264 102.459 66.9737 99.2775 62.9701 95.7986C57.4752 91.1225 52.6808 85.6811 48.7339 79.6412C47.4482 77.6274 46.327 75.5132 45.3812 73.3191C45.9369 73.1441 46.4926 72.9692 47.0409 72.7565L47.029 72.7354ZM43.4862 67.8998C43.1601 66.8307 43.0267 65.7082 42.7956 64.5853C42.7124 64.0195 42.6833 63.4509 42.6107 62.8791L42.5228 62.0095L42.5221 61.1462C42.4528 58.7661 42.7319 56.3886 43.3504 54.0892C44.0065 51.6603 45.0047 49.337 46.315 47.1891C47.665 44.8794 49.2338 42.7048 50.9997 40.6951L51.6783 39.9492L52.3986 39.2772C52.8665 38.8172 53.3632 38.3874 53.8856 37.9904C54.3858 37.6017 54.9076 37.2415 55.4484 36.9115C55.9708 36.6141 56.5172 36.361 57.0819 36.1548C58.0155 35.7022 59.0732 35.5735 60.0881 35.7891C61.1029 36.0046 62.017 36.5521 62.6861 37.3451C64.0769 39.295 64.7488 41.6667 64.5873 44.0563C64.4873 46.7312 63.924 49.3685 62.9226 51.8509C61.88 54.4673 60.5227 56.9469 58.8806 59.2351C57.2951 61.5697 55.386 63.6671 53.2105 65.4645C51.0022 67.2219 48.5304 68.6198 45.8864 69.6068C45.3169 69.8314 44.7296 70.0243 44.1633 70.2053C43.902 69.4477 43.6558 68.6676 43.4234 67.8379"
                      fill="#CACFD8"
                    ></path>
                  </svg>
                </span> */}
            </p>
            <ul className="my-3 flex-column  align-items-start">
              <li className="my-2">
                <i
                  className="bi bi-circle-fill fs-6 mx-2"
                  style={{ color: "var(--brown)" }}
                ></i>
                گرفتن نشان تأیید و اعتماد متامارس
              </li>
              <li className="my-2">
                <i
                  className="bi bi-circle-fill fs-6 mx-2"
                  style={{ color: "var(--brown)" }}
                ></i>
                اولویت در نتایج جستجو
              </li>

              <li className="my-2">
                <i
                  className="bi bi-circle-fill fs-6 mx-2"
                  style={{ color: "var(--brown)" }}
                ></i>
                تبلیغات ویژه در جایگاه‌های ویژه
              </li>
              <li className="my-2">
                <i
                  className="bi bi-circle-fill fs-6 mx-2"
                  style={{ color: "var(--brown)" }}
                ></i>
                نمایش امکانات با آیکون‌های جذاب
              </li>
              <li className="my-2">
                <i
                  className="bi bi-circle-fill fs-6 mx-2"
                  style={{ color: "var(--brown)" }}
                ></i>
                افزودن ویدیو به صفحه کسب و کار
              </li>

              <li className="my-2">
                <i
                  className="bi bi-circle-fill fs-6 mx-2"
                  style={{ color: "var(--brown)" }}
                ></i>
                آگهی ویژه طبقه‌بندی
              </li>
              <li className="my-2">
                <i
                  className="bi bi-circle-fill fs-6 mx-2"
                  style={{ color: "var(--brown)" }}
                ></i>
                نمایش صفحه‌ی کسب و کار شما در سراسر دنیا
              </li>
            </ul>
            {/* <!-- <button type="button" className="btn btn-danger wrn-btn wrn-btn-rounded w-50 "> --> */}
            <Link
              className="btn primary-btn view-cart cart-footer w-75 mx-md-5 mx-0 "
              to={`/${window.lang}/store/plans`}
            >
              <i className="bi bi-pencil-square p-1"></i>
              بیشتر دیده شوید!
            </Link>
            {/* <!-- </button> --> */}
          </div>
          <div className="col-md-5 d-flex align-items-center justify-content-center img-banner-2 ">
            {/* <img className="w-100" src="/img/illustration/bullseye.svg" alt="boost up" /> */}
            <img
              className="w-100"
              src="/img/illustration/the-best-team-gets-the-trophy.svg"
              alt="boost up"
            />

            {/* <img src="/img/illustration/business-goal.svg" alt="arrow" /> */}
          </div>
        </div>
      </div>
      <div className="mx-md-5  ">
        {/* <!-- تازه‌های بلاگ --> */}
        <div className="similar-blog mx-auto py-3 ">
          <div className="divider2 ">
             
            <svg
              className="text-dark-550 dark:text-white ml-2"
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="15" cy="27" r="11" fill="currentColor"></circle>
              <circle
                cx="35"
                cy="16"
                r="8"
                fill="currentColor"
                fillOpacity="0.4"
              ></circle>
              <circle
                cx="20"
                cy="8"
                r="5"
                fill="currentColor"
                fillOpacity="0.7"
              ></circle>
              {/* <!-- <line x1="30" y1="20" x2="560" y2="20" stroke="currentColor" />  --> */}
            </svg>
            <span className="p-0 mb-0 ">تازه‌های بلاگ</span>
            {/* <!-- <img src="/img/Images/arrow-09-svgrepo-com.svg"  className="arrow" alt="arrow"> --> */}
          </div>

          <HorizontalSlider data={pubData.newPosts} section="blog" />
        </div>
        {/* <!-- تازه‌های بلاگ end of --> */}
      </div>

      {/* <!-- ********** back to top************************* --> */}
      <div className="row backtotop">
        <div className="col-12">
          <Link
            href="#top"
            data-bs-toggle="tooltip"
            data-bs-placement="right"
            title="بازگشت به آغاز صفحه"
            className="tooltip-color"
          >
            <i className=" bi bi-arrow-up-circle-fill backtotop-btn"></i>
          </Link>
        </div>
      </div>

      {/* <!-- *********************************** end of main ******************************************************************** --> */}

      {/* <!-- ***JavaScript*** --> */}

      {/* <div>
       
        <script
          src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js"
          integrity="sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM"
          crossOrigin="anonymous"
        ></script>

      
      </div> */}
    </div>
  );
}
